// extracted by mini-css-extract-plugin
export default {"App":"App_App__+psRD","App-logo":"App_App-logo__5m5yY","App-logo-spin":"App_App-logo-spin__tBHax","App-header":"App_App-header__+d0Ea","App-link":"App_App-link__g5-Wy"};